(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.getElementById('rutina-cart-form');
    if (!form) return;

    // Update one line by its stable item key using Shopify Cart AJAX API.
    // Using the key (not line index) avoids stale-line errors on the remove button,
    // and posting to /cart/change.js (not the form) avoids the "checkout" redirect.
    function updateLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          // Fallback: let the page reload from the standard cart URL.
          window.location.href = '{{ routes.cart_url }}';
        });
    }

    form.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var wrap = input.closest('.rutina-cart__item-qty');
      if (!wrap) return;
      var key = input.getAttribute('data-item-key');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');

      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        if (v > 0) { input.value = v - 1; updateLine(key, v - 1); }
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = v + 1; updateLine(key, v + 1);
      });

      var debounce;
      input.addEventListener('change', function () {
        clearTimeout(debounce);
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        debounce = setTimeout(function () { updateLine(key, v); }, 200);
      });
    });

    // Remove button — AJAX by item key (quantity 0). Stops the <a> from
    // navigating to a stale url_to_remove that can hit an error page.
    form.querySelectorAll('[data-cart-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var key = link.getAttribute('data-item-key');
        if (!key) return; // no key -> let the href work as fallback
        e.preventDefault();
        updateLine(key, 0);
      });
    });

    var discountBtn = form.querySelector('[data-discount-apply]');
    var discountInput = form.querySelector('[data-discount-input]');
    if (discountBtn && discountInput) {
      discountBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var code = (discountInput.value || '').trim();
        if (!code) { discountInput.focus(); return; }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
      discountInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); discountBtn.click(); }
      });
    }

    var grid = document.querySelector('[data-rec-grid]');
    var prevBtn = document.querySelector('[data-rec-prev]');
    var nextBtn = document.querySelector('[data-rec-next]');
    if (grid && prevBtn && nextBtn) {
      function scrollByOne(dir) {
        var card = grid.querySelector('li');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 20;
        grid.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      function updateArrows() {
        var max = grid.scrollWidth - grid.clientWidth - 1;
        prevBtn.disabled = grid.scrollLeft <= 0;
        nextBtn.disabled = grid.scrollLeft >= max;
      }
      prevBtn.addEventListener('click', function () { scrollByOne(-1); });
      nextBtn.addEventListener('click', function () { scrollByOne(1); });
      grid.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rutina-featured').forEach(function (root) {
      var tabs = root.querySelectorAll('.rutina-featured__tab');
      var panels = root.querySelectorAll('.rutina-featured__panel');
      var chips = root.querySelectorAll('.rutina-featured__chip');
      var arrows = root.querySelectorAll('.rutina-featured__arrow');

      function activePanel() {
        return root.querySelector('.rutina-featured__panel.is-active');
      }
      function activeFilter() {
        var c = root.querySelector('.rutina-featured__chip.is-active');
        return c ? (c.getAttribute('data-filter') || '') : '';
      }
      function activeGrid() {
        var panel = activePanel();
        return panel ? panel.querySelector('.rutina-featured__grid') : null;
      }

      function updateArrows() {
        var grid = activeGrid();
        var prev = root.querySelector('.rutina-featured__arrow[data-direction="prev"]');
        var next = root.querySelector('.rutina-featured__arrow[data-direction="next"]');
        if (!grid) return;
        var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
        if (prev) prev.disabled = grid.scrollLeft <= 2;
        if (next) next.disabled = grid.scrollLeft >= maxScroll;
      }

      function applyFilter() {
        var panel = activePanel();
        if (!panel) return;
        var filter = activeFilter();
        var cards = panel.querySelectorAll('.rutina-featured__card');
        var visible = 0;
        cards.forEach(function (card) {
          var needs = (card.getAttribute('data-needs') || '').split(/\s+/);
          var show = !filter || needs.indexOf(filter) !== -1;
          card.hidden = !show;
          if (show) visible++;
        });
        var empty = panel.querySelector('.rutina-featured__empty');
        if (empty) empty.hidden = visible !== 0;
        var grid = panel.querySelector('.rutina-featured__grid');
        if (grid) grid.scrollLeft = 0;
        updateArrows();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.id === target);
          });
          /* Reset subfilter to the first chip on tab change */
          chips.forEach(function (c, i) { c.classList.toggle('is-active', i === 0); });
          applyFilter();
        });
      });

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          applyFilter();
        });
      });

      arrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var grid = activeGrid();
          if (!grid) return;
          var dir = arrow.getAttribute('data-direction') === 'next' ? 1 : -1;
          grid.scrollBy({ left: dir * grid.clientWidth, behavior: 'smooth' });
        });
      });

      root.querySelectorAll('.rutina-featured__grid').forEach(function (grid) {
        grid.addEventListener('scroll', function () { updateArrows(); });
      });

      window.addEventListener('resize', updateArrows);
      applyFilter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('rutina-gc-form');
    if (!form) return;
    var priceDisplay = form.parentElement.querySelector('[data-price-display]');
    var inputs = form.querySelectorAll('.rutina-gc__amount-input');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (this.checked) {
          // Update label states
          form.querySelectorAll('.rutina-gc__amount').forEach(function (l) { l.classList.remove('is-selected'); });
          this.closest('.rutina-gc__amount').classList.add('is-selected');
          // Update price display
          if (priceDisplay && this.dataset.price) {
            priceDisplay.textContent = this.dataset.price;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      root.querySelectorAll('[data-lp-add]').forEach(function (btn) {
        if (btn.dataset.lpBound) return;
        btn.dataset.lpBound = '1';
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-variant-id');
          if (!id || id === '0') return;
          btn.classList.add('is-loading');
          var done = function () { btn.classList.remove('is-loading'); };
          if (window.RutinaCart) {
            window.RutinaCart
              .add([{ id: Number(id), quantity: 1 }], {
                label: btn.getAttribute('data-label'),
                value: Number(btn.getAttribute('data-value')) || null
              })
              .then(done, done);
          } else {
            window.location.href = '/cart/' + id + ':1';
          }
        });
      });
    }
    function slideshow(root) {
      if (root.dataset.lpBound) return;
      root.dataset.lpBound = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lp-hero-slide]'));
      if (slides.length < 2) return;

      var media = root.closest('.lp-hero__media') || root.parentNode;
      var dots = Array.prototype.slice.call(media.querySelectorAll('[data-lp-hero-dot]'));
      var interval = Number(root.getAttribute('data-interval')) || 4500;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      var timer = null;

      function show(next) {
        slides[current].classList.remove('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = (next + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }
      }

      function start() {
        if (reduced || timer) return;
        timer = setInterval(function () { show(current + 1); }, interval);
      }
      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stop();
          show(i);
          start();
        });
      });

      /* Sustabdoma, kai kursorius ant nuotraukos arba kortelė nematoma. */
      media.addEventListener('mouseenter', stop);
      media.addEventListener('mouseleave', start);
      media.addEventListener('focusin', stop);
      media.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      start();
    }

    document.querySelectorAll('[data-lp-hero-slides]').forEach(slideshow);
    document.querySelectorAll('.lp-hero').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.lp-hero');
      if (el) bind(el);
      var sl = e.target.querySelector('[data-lp-hero-slides]');
      if (sl) slideshow(sl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-offer-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(box) {
      if (box.dataset.lpBound) return;
      box.dataset.lpBound = '1';

      var radios = Array.prototype.slice.call(box.querySelectorAll('.lp-tier__input'));
      var btn = box.querySelector('[data-lp-tiers-add]');
      var priceEl = box.querySelector('[data-lp-tiers-price]');
      var shipEl = box.querySelector('[data-lp-tiers-ship]');
      var shipThreshold = Number(box.getAttribute('data-ship-threshold')) || 0;
      if (!radios.length || !btn) return;

      function current() {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return radios[i];
        }
        for (var j = 0; j < radios.length; j++) {
          if (!radios[j].disabled) { radios[j].checked = true; return radios[j]; }
        }
        return null;
      }

      function sync() {
        var r = current();
        if (!r) return;
        var value = Number(r.getAttribute('data-value')) || 0;
        if (priceEl) priceEl.textContent = r.getAttribute('data-price') || '';
        if (shipEl) shipEl.hidden = !(shipThreshold > 0 && value >= shipThreshold);
        document.dispatchEvent(new CustomEvent('lp:tier', {
          detail: {
            items: r.value,
            label: r.getAttribute('data-label') || '',
            price: r.getAttribute('data-price') || '',
            value: value
          }
        }));
      }

      function add() {
        var r = current();
        if (!r || btn.disabled) return;
        btn.classList.add('is-loading');
        var done = function () { btn.classList.remove('is-loading'); };
        var items = [{ id: Number(r.value), quantity: 1 }];
        if (window.RutinaCart) {
          window.RutinaCart.add(items, {
            label: r.getAttribute('data-label') || '',
            value: Number(r.getAttribute('data-value')) || null
          }).then(done, done);
        } else {
          window.location.href = '/cart/' + r.value + ':1';
        }
      }

      radios.forEach(function (r) { r.addEventListener('change', sync); });
      btn.addEventListener('click', add);
      document.addEventListener('lp:add-selected', add);
      sync();
    }

    document.querySelectorAll('[data-lp-tiers]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-lp-tiers]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (form.dataset.lpBound) return;
      form.dataset.lpBound = '1';

      var radios = form.querySelectorAll('.lp-offer__radio');
      var btn = form.querySelector('[data-lp-offer-add]');
      var priceEl = form.querySelector('[data-lp-offer-price]');
      var summaryEl = form.querySelector('[data-lp-summary]');
      var giftEl = form.querySelector('[data-lp-gift]');
      if (!radios.length || !btn) return;

      function selected() {
        return form.querySelector('.lp-offer__radio:checked') || radios[0];
      }

      function update() {
        var r = selected();
        if (!r) return;

        if (priceEl) priceEl.textContent = r.getAttribute('data-total') || '';
        if (giftEl) giftEl.hidden = r.getAttribute('data-gift') !== 'true';
        if (summaryEl) {
          var parts = [r.getAttribute('data-label') || ''];
          if (Number(r.getAttribute('data-saving')) > 0) {
            parts.push('sutaupai ' + r.getAttribute('data-saving-text'));
          }
          summaryEl.textContent = parts.filter(Boolean).join(' · ');
        }
        btn.disabled = !!r.disabled;

        document.dispatchEvent(new CustomEvent('lp:tier', {
          detail: {
            items: r.getAttribute('data-variant'),
            label: r.getAttribute('data-label'),
            price: r.getAttribute('data-total'),
            value: Number(r.getAttribute('data-value')) || null
          }
        }));
      }

      radios.forEach(function (r) { r.addEventListener('change', update); });

      function add() {
        var r = selected();
        if (!r || r.disabled) return;
        var id = Number(r.getAttribute('data-variant'));
        var addonId = Number(r.getAttribute('data-addon-variant'));
        var addons = Number(r.getAttribute('data-addons')) || 0;
        if (!id) return;

        var lines = [{ id: id, quantity: 1 }];
        if (addonId && addons > 0) lines.push({ id: addonId, quantity: addons });

        btn.classList.add('is-loading');
        var done = function () { btn.classList.remove('is-loading'); };
        if (window.RutinaCart) {
          window.RutinaCart
            .add(lines, { label: r.getAttribute('data-label'), value: Number(r.getAttribute('data-value')) || null })
            .then(done, done);
        } else {
          var path = lines.map(function (l) { return l.id + ':' + l.quantity; }).join(',');
          window.location.href = '/cart/' + path;
        }
      }

      btn.addEventListener('click', add);
      document.addEventListener('lp:add-selected', add);
      update();
    }

    document.querySelectorAll('[data-lp-offer]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-lp-offer]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.lpBound) return;
      root.dataset.lpBound = '1';

      var track = root.querySelector('[data-lp-reviews-track]');
      var prev = root.querySelector('[data-lp-reviews-prev]');
      var next = root.querySelector('[data-lp-reviews-next]');
      if (!track) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var card = track.querySelector('li');
        if (!card) return Math.round(track.clientWidth * 0.8);
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        root.classList.toggle('is-static', max <= 4);
        if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 4);
        if (next) next.classList.toggle('is-off', track.scrollLeft >= max - 4);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      update();
    }

    document.querySelectorAll('[data-lp-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-lp-reviews]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(bar) {
      if (bar.dataset.lpBound) return;
      bar.dataset.lpBound = '1';

      var labelEl = bar.querySelector('[data-lp-sticky-label]');
      var priceEl = bar.querySelector('[data-lp-sticky-price]');
      var btn = bar.querySelector('[data-lp-sticky-btn]');
      var offer = document.querySelector(bar.dataset.offerSelector || '.lp-offer');
      var trigger = document.querySelector(bar.dataset.triggerSelector || '.lp-hero__buy');

      var state = { items: '', label: '', value: null };
      var passedHero = false;
      var offerVisible = false;

      function render() {
        var show = passedHero && !offerVisible;
        bar.hidden = !show;
        requestAnimationFrame(function () {
          bar.classList.toggle('is-visible', show);
        });
      }

      document.addEventListener('lp:tier', function (e) {
        state.items = e.detail.items || '';
        state.label = e.detail.label || '';
        state.value = e.detail.value;
        if (labelEl && state.label) labelEl.textContent = state.label;
        if (priceEl) priceEl.textContent = e.detail.price || '';
      });

      if ('IntersectionObserver' in window) {
        if (trigger) {
          new IntersectionObserver(function (entries) {
            passedHero = entries[0].boundingClientRect.top < 0 || !entries[0].isIntersecting;
            render();
          }, { threshold: 0 }).observe(trigger);
        } else {
          passedHero = true;
        }
        if (offer) {
          new IntersectionObserver(function (entries) {
            offerVisible = entries[0].isIntersecting;
            render();
          }, { threshold: 0.15 }).observe(offer);
        }
      } else {
        passedHero = true;
      }
      render();

      btn.addEventListener('click', function () {
        var action = bar.dataset.action;
        if (action === 'scroll' || !state.items) {
          if (offer) {
            offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
        }
        var items = state.items.split(',').filter(Boolean).map(function (id) {
          return { id: Number(id), quantity: 1 };
        });
        if (!items.length) return;
        btn.classList.add('is-loading');
        var done = function () { btn.classList.remove('is-loading'); };
        if (window.RutinaCart) {
          window.RutinaCart.add(items, { label: state.label, value: state.value }).then(done, done);
        } else {
          window.location.href = '/cart/' + items.map(function (i) { return i.id + ':1'; }).join(',');
        }
      });
    }

    document.querySelectorAll('[data-lp-sticky]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-lp-sticky]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(frame) {
      if (frame.dataset.lpBound) return;
      frame.dataset.lpBound = '1';

      var video = frame.querySelector('video');
      var toggle = frame.querySelector('[data-lp-video-toggle]');
      if (!video) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var userPaused = reduced;

      function play() {
        if (userPaused) return;
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* naršyklė neleido — lieka posteris */ });
        frame.classList.remove('is-paused');
      }

      if (reduced) {
        video.removeAttribute('autoplay');
        video.pause();
        frame.classList.add('is-paused');
      } else {
        /* Groja iš karto, nelaukiant slinkimo. */
        play();
        if (video.readyState < 2) {
          video.addEventListener('canplay', play, { once: true });
        }
      }

      /* Praslinkus — pauzė (taupo bateriją ir duomenis), grįžus — tęsia. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play();
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0 }).observe(frame);
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            play();
            toggle.setAttribute('aria-label', 'Pristabdyti vaizdo įrašą');
          } else {
            userPaused = true;
            video.pause();
            frame.classList.add('is-paused');
            toggle.setAttribute('aria-label', 'Paleisti vaizdo įrašą');
          }
        });
      }
    }

    document.querySelectorAll('[data-lp-video]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-lp-video]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // ===== AJAX add-to-cart: add the item, open the cart drawer, stay on the page =====
    var atcForm = document.getElementById('product-form-main');
    if (atcForm) {
      atcForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = atcForm.querySelector('[type="submit"]');
        var label = atcForm.querySelector('.rutina-product__atc-label');
        var originalLabel = label ? label.innerHTML : null;
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Pridedama…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: new FormData(atcForm)
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            return fetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (window.RutinaCart) {
                  window.RutinaCart.updateCount(cart.item_count);
                  window.RutinaCart.refreshAndOpen();
                }
              });
          })
          .catch(function () {
            window.location.href = '/cart';
          })
          .then(function () {
            if (btn) btn.disabled = false;
            if (label && originalLabel !== null) label.innerHTML = originalLabel;
          });
      });
    }

    document.querySelectorAll('.rutina-product').forEach(function (root) {
      // Gallery: thumb click + keyboard arrows + touch swipe
      var gallery = root.querySelector('[data-gallery]');
      var thumbs = root.querySelectorAll('[data-thumb]');
      var slides = root.querySelectorAll('[data-slide]');
      var slideCount = slides.length;

      function activateSlide(idx) {
        if (!slideCount) return;
        if (idx < 0) idx = slideCount - 1;
        if (idx >= slideCount) idx = 0;
        var idxStr = String(idx);
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === idxStr); });
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === idxStr); });
        // Scroll the active thumb into view in case the thumbs row overflows
        var activeThumb = root.querySelector('[data-thumb="' + idxStr + '"]');
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
      function getActiveSlideIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      // Thumb click
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateSlide(parseInt(thumb.getAttribute('data-thumb'), 10));
        });
      });

      // Keyboard ← / → arrows (desktop) — skipped while typing in inputs
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var ae = document.activeElement;
        if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.tagName === 'SELECT' || ae.isContentEditable)) return;
        if (!slideCount || slideCount < 2) return;
        e.preventDefault();
        activateSlide(getActiveSlideIndex() + (e.key === 'ArrowRight' ? 1 : -1));
      });

      // Touch swipe (mobile) — horizontal swipe changes image
      if (gallery && slideCount > 1) {
        var tStartX = null, tStartY = null, tStartT = 0;
        gallery.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tStartX = null; return; }
          tStartX = e.touches[0].clientX;
          tStartY = e.touches[0].clientY;
          tStartT = Date.now();
        }, { passive: true });
        gallery.addEventListener('touchend', function (e) {
          if (tStartX === null) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - tStartX;
          var dy = t.clientY - tStartY;
          var dt = Date.now() - tStartT;
          // Threshold: 40px horizontal, must be more horizontal than vertical, within 600ms
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4 && dt < 600) {
            activateSlide(getActiveSlideIndex() + (dx < 0 ? 1 : -1));
          }
          tStartX = null; tStartY = null;
        }, { passive: true });
      }

      // Tabs
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === target); });
        });
      });

      // Related products — carousel arrows navigation
      var relatedGrid = root.querySelector('[data-related-grid]');
      var relatedPrev = root.querySelector('[data-related-prev]');
      var relatedNext = root.querySelector('[data-related-next]');
      if (relatedGrid && (relatedPrev || relatedNext)) {
        function getScrollStep() {
          var card = relatedGrid.querySelector('.rutina-product__related-card');
          if (!card) return 300;
          var styles = window.getComputedStyle(relatedGrid);
          var gap = parseFloat(styles.gap || styles.columnGap || '24');
          return card.offsetWidth + gap;
        }
        function updateRelatedArrows() {
          var maxScroll = relatedGrid.scrollWidth - relatedGrid.clientWidth - 4;
          if (relatedPrev) relatedPrev.disabled = relatedGrid.scrollLeft <= 4;
          if (relatedNext) relatedNext.disabled = relatedGrid.scrollLeft >= maxScroll;
        }
        if (relatedPrev) {
          relatedPrev.addEventListener('click', function () {
            relatedGrid.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
          });
        }
        if (relatedNext) {
          relatedNext.addEventListener('click', function () {
            relatedGrid.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
          });
        }
        relatedGrid.addEventListener('scroll', updateRelatedArrows, { passive: true });
        window.addEventListener('resize', updateRelatedArrows);
        updateRelatedArrows();
      }

      // Smooth-scroll to reviews from rating link
      var ratingLink = root.querySelector('.rutina-product__rating');
      if (ratingLink) {
        ratingLink.addEventListener('click', function (e) {
          var target = root.querySelector('#reviews');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      // Money formatter (Lithuanian locale)
      function formatMoneyLT(cents) {
        var euros = (cents / 100).toFixed(2).replace('.', ',');
        return '€' + euros;
      }

      // Element references
      var atcPriceEl = root.querySelector('[data-atc-price]');
      var hiddenQtyInput = root.querySelector('[data-quantity-input]');
      var visibleQtyInput = root.querySelector('[data-qty-input]');
      var qtyDecreaseBtn = root.querySelector('[data-qty-decrease]');
      var qtyIncreaseBtn = root.querySelector('[data-qty-increase]');
      var priceCurrentEl = root.querySelector('.rutina-product__price-current');
      var hiddenIdInput = root.querySelector('input[name="id"]');
      var variantInputs = root.querySelectorAll('input[name="variant"]');

      // Helper: get currently selected unit price in cents
      function getCurrentUnitPriceCents() {
        var checkedVariant = root.querySelector('input[name="variant"]:checked');
        if (checkedVariant) {
          return parseInt(checkedVariant.getAttribute('data-variant-price'), 10);
        }
        // Fallback: parse from displayed price
        if (priceCurrentEl) {
          var txt = priceCurrentEl.textContent.replace(/[^\d,.-]/g, '').replace(',', '.');
          var parsed = parseFloat(txt);
          if (!isNaN(parsed)) return Math.round(parsed * 100);
        }
        return 0;
      }

      // Helper: recalculate and update ATC price = unit × qty
      function recalcAtcPrice() {
        if (!atcPriceEl) return;
        var unitCents = getCurrentUnitPriceCents();
        var qty = parseInt(visibleQtyInput ? visibleQtyInput.value : 1, 10) || 1;
        atcPriceEl.textContent = formatMoneyLT(unitCents * qty);
      }

      // Quantity stepper handlers
      function updateQty(newVal) {
        if (newVal < 1) newVal = 1;
        if (visibleQtyInput) visibleQtyInput.value = newVal;
        if (hiddenQtyInput) hiddenQtyInput.value = newVal;
        if (qtyDecreaseBtn) qtyDecreaseBtn.disabled = (newVal <= 1);
        recalcAtcPrice();
      }
      if (qtyDecreaseBtn) {
        qtyDecreaseBtn.addEventListener('click', function () {
          var current = parseInt(visibleQtyInput.value, 10) || 1;
          updateQty(current - 1);
        });
      }
      if (qtyIncreaseBtn) {
        qtyIncreaseBtn.addEventListener('click', function () {
          var current = parseInt(visibleQtyInput.value, 10) || 1;
          updateQty(current + 1);
        });
      }
      if (visibleQtyInput) {
        visibleQtyInput.addEventListener('change', function () {
          var current = parseInt(visibleQtyInput.value, 10) || 1;
          updateQty(current);
        });
        // Initialize button state on load
        updateQty(parseInt(visibleQtyInput.value, 10) || 1);
      }

      // Variant selector — update main price + ATC price + variant ID
      variantInputs.forEach(function (vInput) {
        vInput.addEventListener('change', function () {
          if (!vInput.checked) return;
          var variantId = vInput.getAttribute('data-variant-id');
          var priceCents = parseInt(vInput.getAttribute('data-variant-price'), 10);
          if (isNaN(priceCents)) return;

          // Toggle chip selected state
          root.querySelectorAll('.rutina-product__variant-chip').forEach(function (chip) {
            chip.classList.toggle('is-selected', chip.contains(vInput));
          });

          // Update main displayed price
          if (priceCurrentEl) priceCurrentEl.textContent = formatMoneyLT(priceCents);

          // Recalc ATC price using current qty
          recalcAtcPrice();

          // Update hidden form variant ID for cart submission
          if (hiddenIdInput) hiddenIdInput.value = variantId;

          // Update URL with variant param (for shareability + page refresh)
          if (window.history && window.history.replaceState) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', variantId);
              window.history.replaceState({}, '', url.toString());
            } catch (e) { /* ignore */ }
          }
        });
      });

      // Info modal — open/close
      var infoOpenBtns = root.querySelectorAll('[data-info-open]');
      var infoModals = root.querySelectorAll('[data-info-modal]');
      function closeModal(modal) {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
      infoOpenBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-info-open');
          var modal = root.querySelector('[data-info-modal="' + key + '"]');
          if (modal) {
            modal.removeAttribute('hidden');
            document.body.style.overflow = 'hidden';
          }
        });
      });
      infoModals.forEach(function (modal) {
        modal.querySelectorAll('[data-info-close]').forEach(function (closer) {
          closer.addEventListener('click', function () { closeModal(modal); });
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoModals.forEach(function (modal) {
            if (!modal.hasAttribute('hidden')) closeModal(modal);
          });
        }
      });

      // Reviews — smart pagination (1 2 3 ... last)
      var reviewsList = root.querySelector('[data-reviews-list]');
      var paginationNav = root.querySelector('[data-reviews-pagination]');
      var reviewItems = reviewsList ? reviewsList.querySelectorAll('.rutina-product__review') : [];
      if (reviewsList && paginationNav && reviewItems.length > 0) {
        var perPage = 5;
        var totalReviews = reviewItems.length;
        var totalPages = Math.ceil(totalReviews / perPage);
        var currentPage = 1;

        function getPageList(current, total) {
          if (total <= 5) {
            var arr = [];
            for (var i = 1; i <= total; i++) arr.push(i);
            return arr;
          }
          if (current <= 3) return [1, 2, 3, '...', total];
          if (current >= total - 2) return [1, '...', total - 2, total - 1, total];
          return [1, '...', current - 1, current, current + 1, '...', total];
        }

        function showPageReviews(page) {
          reviewItems.forEach(function (item, idx) {
            var start = (page - 1) * perPage;
            var end = start + perPage;
            if (idx >= start && idx < end) {
              item.removeAttribute('hidden');
            } else {
              item.setAttribute('hidden', '');
            }
          });
        }

        function renderPagination() {
          var pages = getPageList(currentPage, totalPages);
          var html = '';
          // Prev arrow — only show if not on page 1
          if (currentPage > 1) {
            html += '<button type="button" class="rutina-product__pagination-arrow" data-page-prev aria-label="Ankstesnis puslapis">';
            html += '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            html += '</button>';
          }
          pages.forEach(function (p) {
            if (p === '...') {
              html += '<span class="rutina-product__pagination-ellipsis" aria-hidden="true">...</span>';
            } else {
              var active = (p === currentPage);
              html += '<button type="button" class="rutina-product__pagination-num' + (active ? ' is-active' : '') + '" data-page="' + p + '" aria-label="Puslapis ' + p + '"' + (active ? ' aria-current="page"' : '') + '>' + p + '</button>';
            }
          });
          // Next arrow — only show if not on last page
          if (currentPage < totalPages) {
            html += '<button type="button" class="rutina-product__pagination-arrow" data-page-next aria-label="Kitas puslapis">';
            html += '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            html += '</button>';
          }
          paginationNav.innerHTML = html;
          attachPaginationEvents();
        }

        function attachPaginationEvents() {
          paginationNav.querySelectorAll('[data-page]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var page = parseInt(btn.getAttribute('data-page'), 10);
              goToPage(page);
            });
          });
          var prevBtn = paginationNav.querySelector('[data-page-prev]');
          var nextBtn = paginationNav.querySelector('[data-page-next]');
          if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });
        }

        function goToPage(page) {
          if (page < 1 || page > totalPages) return;
          currentPage = page;
          showPageReviews(page);
          renderPagination();
          if (reviewsList) reviewsList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Init
        showPageReviews(1);
        renderPagination();
      }

      // Sticky ATCs — show when main ATC scrolls out of view (mobile bottom + desktop left),
      // BUT hide once the cross-sell ("Klientės taip pat pirko") section or the footer
      // enters view, so the sticky never overlaps product photos or the footer.
      var stickyBar = root.querySelector('[data-sticky-atc]');
      var stickyLeft = root.querySelector('[data-sticky-left-atc]');
      var mainAtc = root.querySelector('.rutina-product__atc');
      var stickyBtn = root.querySelector('[data-sticky-add]');
      var stickyLeftBtn = root.querySelector('[data-sticky-left-add]');
      if (mainAtc && 'IntersectionObserver' in window) {
        var atcOut = false;
        var endReached = false;
        var updateSticky = function () {
          var show = atcOut && !endReached;
          if (stickyBar) stickyBar.classList.toggle('is-visible', show);
          if (stickyLeft) stickyLeft.classList.toggle('is-visible', show);
        };

        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            atcOut = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          });
          updateSticky();
        }, { threshold: 0 }).observe(mainAtc);

        var endZones = [];
        var relatedEl = root.querySelector('.rutina-product__related');
        if (relatedEl) endZones.push(relatedEl);
        var footerEl = document.querySelector('.rutina-footer');
        if (footerEl) endZones.push(footerEl);
        if (endZones.length) {
          var endObserver = new IntersectionObserver(function () {
            endReached = endZones.some(function (el) {
              var r = el.getBoundingClientRect();
              return r.top < window.innerHeight && r.bottom > 0;
            });
            updateSticky();
          }, { threshold: 0 });
          endZones.forEach(function (el) { endObserver.observe(el); });
        }
      }
      if (stickyBtn) stickyBtn.addEventListener('click', function () { if (mainAtc) mainAtc.click(); });
      if (stickyLeftBtn) stickyLeftBtn.addEventListener('click', function () { if (mainAtc) mainAtc.click(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rutina-reviews').forEach(function (root) {
      var track = root.querySelector('.rutina-reviews__track');
      if (!track) return;
      var arrows = root.querySelectorAll('.rutina-reviews__arrow');
      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-direction');
          var card = track.querySelector('.rutina-reviews__card');
          var step = (card ? card.getBoundingClientRect().width : 320) + 24;
          track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.routineBuilderInit === 'true') return;
      root.dataset.routineBuilderInit = 'true';

      const discount = parseFloat(root.dataset.bundleDiscount || '0') / 100;
      const products = Array.from(root.querySelectorAll('[data-routine-product]'));
      const levelName = root.querySelector('[data-routine-level-name]');
      const levelWrap = root.querySelector('[data-routine-level-wrap]');
      const hint = root.querySelector('[data-routine-hint]');
      const stepEls = Array.from(root.querySelectorAll('[data-routine-steps] [data-step]'));
      const progressFill = root.querySelector('[data-routine-progress]');
      const hasProgress = stepEls.length > 0 && !!progressFill;
      const countEl = root.querySelector('[data-routine-count]');
      const countNoun = root.querySelector('[data-routine-count-noun]');
      const durationEl = root.querySelector('[data-routine-duration]');
      const priceNow = root.querySelector('[data-routine-price-now]');
      const priceOriginal = root.querySelector('[data-routine-price-original]');
      const priceDiscount = root.querySelector('[data-routine-price-discount]');
      const savings = root.querySelector('[data-routine-savings]');
      const savingsAmount = root.querySelector('[data-routine-savings-amount]');
      const ctaBtn = root.querySelector('[data-routine-add-all]');
      const ctaLabel = root.querySelector('[data-routine-cta-label]');
      const nudgeEl = root.querySelector('[data-routine-nudge]');
      const thumbsEl = root.querySelector('[data-routine-thumbs]');
      const summaryEl = root.querySelector('[data-routine-summary]');

      function fmt(value) {
        const rounded = Math.round(value * 100) / 100;
        return '€ ' + rounded.toFixed(2);
      }

      function nounFor(count) {
        if (count === 1) return ' produktas';
        if (count > 1 && count < 10 && count % 10 !== 0) return ' produktai';
        return ' produktų';
      }

      function getSelected() {
        return products.filter((p) => p.querySelector('[data-routine-toggle]').checked);
      }

      function determineLevel(selected) {
        const tiers = selected.map((p) => p.dataset.tier);
        const essentialCount = tiers.filter((t) => t === 'essential').length;
        const hasIntermediate = tiers.includes('intermediate');
        const hasAdvanced = tiers.includes('advanced');
        const totalEssentials = products.filter((p) => p.dataset.tier === 'essential').length;

        const hasAllEssentials = essentialCount === totalEssentials && totalEssentials > 0;
        const routineHasAddons = products.some((p) => p.dataset.tier !== 'essential');

        // Rutina be papildomų produktų (pvz., Žalioji) — pasirinkus visus esminius, rutina pilna
        if (hasAllEssentials && !routineHasAddons) {
          return {
            step: 1,
            name: 'Pilna rutina',
            hint: 'Visa rutina pasirinkta.',
            nudge: 'Visa rutina pasirinkta — geriausias rezultatas ir didžiausias taupymas ✓',
            nudgeSuccess: true,
          };
        }

        if (hasAllEssentials && hasIntermediate && hasAdvanced) {
          return {
            step: 3,
            name: 'Intensyvi rutina',
            hint: 'Maksimali plaukų ir galvos odos priežiūra. Geriausias rezultatas.',
            nudge: 'Visa rutina pasirinkta — gauni maksimalų efektą ir didžiausią taupymą ✓',
            nudgeSuccess: true,
          };
        }
        if (hasAllEssentials && hasIntermediate) {
          return {
            step: 2,
            name: 'Matomiems rezultatams',
            hint: 'Pridėk galvos odos šveitiklį intensyviai rutinai.',
            nudge: 'Pridėk galvos odos šveitiklį → Intensyvi rutina, gilesnis efektas nuo šaknų.',
            nudgeSuccess: false,
          };
        }
        if (hasAllEssentials) {
          return {
            step: 1,
            name: 'Kasdienė rutina',
            hint: 'Pridėk kaukę matomesniems rezultatams.',
            nudge: 'Pridėk kaukę → atrakink „Matomiems rezultatams" lygį su intensyvesniu drėkinimu.',
            nudgeSuccess: false,
          };
        }
        if (selected.length === 0) {
          return {
            step: 0,
            name: 'Pradėk čia',
            hint: 'Pasirink bent 3 produktus, kad sukurtum rutiną.',
            nudge: 'Pasirink bent 3 produktus ir gauk -15% rinkinio nuolaidą.',
            nudgeSuccess: false,
          };
        }
        const missingToBundle = 3 - selected.length;
        if (missingToBundle > 0) {
          return {
            step: 0,
            name: 'Beveik',
            hint: 'Pridėk dar ' + missingToBundle + (missingToBundle === 1 ? ' produktą.' : ' produktus.'),
            nudge: 'Pridėk dar ' + missingToBundle + (missingToBundle === 1 ? ' produktą' : ' produktus') + ', kad aktyvuotum -15% rinkinio nuolaidą.',
            nudgeSuccess: false,
          };
        }
        const missing = totalEssentials - essentialCount;
        return {
          step: 0,
          name: 'Beveik',
          hint: 'Pridėk dar ' + missing + (missing === 1 ? ' esminį' : ' esminius') + ' produktą(-us).',
          nudge: 'Pridėk dar ' + missing + (missing === 1 ? ' esminį produktą' : ' esminius produktus') + ' kompletinei rutinai.',
          nudgeSuccess: false,
        };
      }

      function renderThumbs(selected) {
        if (!thumbsEl) return;
        thumbsEl.innerHTML = '';
        const max = 4;
        const visible = selected.slice(0, max);
        visible.forEach((p) => {
          const img = p.querySelector('img');
          if (!img) return;
          const div = document.createElement('div');
          div.className = 'routine-summary__thumb';
          div.style.backgroundImage = "url('" + img.src + "')";
          thumbsEl.appendChild(div);
        });
        if (selected.length > max) {
          const more = document.createElement('div');
          more.className = 'routine-summary__thumb routine-summary__thumb--more';
          more.textContent = '+' + (selected.length - max);
          thumbsEl.appendChild(more);
        }
      }

      function update() {
        const selected = getSelected();
        const count = selected.length;
        const level = determineLevel(selected);

        // Visual selection state
        products.forEach((p) => {
          const checked = p.querySelector('[data-routine-toggle]').checked;
          p.classList.toggle('routine-product--selected', checked);
        });

        // Level name + hint + nudge — rodom tik kai pasiektas step 2+ (Matomiems rezultatams / Kompleksinė)
        if (levelName && levelWrap) {
          if (level.step >= 2) {
            levelName.textContent = level.name;
            levelWrap.hidden = false;
          } else {
            levelWrap.hidden = true;
          }
        }
        if (hint) hint.textContent = level.hint;
        if (nudgeEl) {
          nudgeEl.textContent = level.nudge;
          nudgeEl.classList.toggle('routine-summary__nudge--success', !!level.nudgeSuccess);
        }

        // Mini thumbs
        renderThumbs(selected);

        // Step states + progress fill (only if progress UI present)
        if (hasProgress) {
          stepEls.forEach((el) => {
            const step = parseInt(el.dataset.step, 10);
            el.classList.toggle('routine-status__step--active', step <= level.step);
          });
          const fillPct = level.step === 0 ? 0 : ((level.step - 1) / 2) * 100;
          progressFill.style.width = fillPct + '%';
        }

        // Count
        countEl.textContent = count;
        countNoun.textContent = nounFor(count);

        // Trukmės eilutė — rodom tik kai pasirinktas bent vienas produktas
        if (durationEl) durationEl.hidden = count === 0;

        // Price — nuolaida tik kai bent 3 produktai, ir netaikoma produktams su data-no-discount (procedūros)
        const sum = selected.reduce((s, p) => s + parseFloat(p.dataset.price || 0), 0);
        const discountableSum = selected
          .filter((p) => !p.hasAttribute('data-no-discount'))
          .reduce((s, p) => s + parseFloat(p.dataset.price || 0), 0);
        const isBundle = count >= 3;
        const savingsValue = isBundle ? discountableSum * discount : 0;
        const finalPrice = sum - savingsValue;

        priceNow.textContent = fmt(finalPrice);
        if (isBundle && savingsValue > 0) {
          priceOriginal.textContent = fmt(sum);
          priceOriginal.hidden = false;
          priceDiscount.hidden = false;
          savings.hidden = false;
          savingsAmount.textContent = fmt(savingsValue);
        } else {
          priceOriginal.hidden = true;
          priceDiscount.hidden = true;
          savings.hidden = true;
        }

        // CTA
        ctaBtn.disabled = count === 0;
        if (count === 0) {
          ctaLabel.textContent = 'Pasirink bent vieną produktą';
        } else if (count === 1) {
          ctaLabel.textContent = 'Pridėti produktą į krepšelį';
        } else if (isBundle) {
          ctaLabel.textContent = 'Pridėti rutiną į krepšelį';
        } else {
          ctaLabel.textContent = 'Pridėti ' + count + ' produktus į krepšelį';
        }
      }

      function addAllToCart() {
        const selected = getSelected();
        if (selected.length === 0) return;
        const ids = selected
          .map((p) => p.dataset.variantId)
          .filter((id) => id && id !== '0');
        if (ids.length === 0) {
          alert('Produktai dar nepriskirti Shopify variant ID. Patikrinkite sekcijos nustatymus.');
          return;
        }
        const path = '/cart/' + ids.map((id) => id + ':1').join(',');
        window.location.href = path;
      }

      // Helper: format price for display (replaces dot with comma)
      function formatProductPrice(value) {
        var num = parseFloat(String(value).replace(',', '.'));
        if (isNaN(num)) return '€0,00';
        return '€' + num.toFixed(2).replace('.', ',');
      }

      products.forEach((p) => {
        p.querySelector('[data-routine-toggle]').addEventListener('change', update);

        // Size pill switching
        const sizeBtns = p.querySelectorAll('[data-routine-size]');
        if (sizeBtns.length > 0) {
          const priceEl = p.querySelector('[data-routine-price]');
          // Ensure initial state matches the selected pill's data
          const initialSelected = p.querySelector('[data-routine-size].is-selected') || sizeBtns[0];
          if (initialSelected) {
            const initPrice = initialSelected.getAttribute('data-size-price');
            const initVariant = initialSelected.getAttribute('data-size-variant');
            if (initPrice) {
              p.dataset.price = initPrice;
              if (priceEl) priceEl.textContent = formatProductPrice(initPrice);
            }
            if (initVariant) p.dataset.variantId = initVariant;
          }

          sizeBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              sizeBtns.forEach((b) => b.classList.remove('is-selected'));
              btn.classList.add('is-selected');
              const newPrice = btn.getAttribute('data-size-price');
              const newVariant = btn.getAttribute('data-size-variant');
              if (newPrice) {
                p.dataset.price = newPrice;
                if (priceEl) priceEl.textContent = formatProductPrice(newPrice);
              }
              if (newVariant) {
                p.dataset.variantId = newVariant;
              }
              update();
            });
          });
        }
      });
      ctaBtn.addEventListener('click', addAllToCart);

      // Info modal — open/close
      const section = root.closest('section') || root;
      const infoOpenBtns = section.querySelectorAll('[data-info-open]');
      const infoModals = section.querySelectorAll('[data-info-modal]');
      function closeModal(modal) {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
      infoOpenBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.getAttribute('data-info-open');
          const modal = section.querySelector('[data-info-modal="' + key + '"]');
          if (modal) {
            modal.removeAttribute('hidden');
            document.body.style.overflow = 'hidden';
          }
        });
      });
      infoModals.forEach((modal) => {
        modal.querySelectorAll('[data-info-close]').forEach((closer) => {
          closer.addEventListener('click', () => closeModal(modal));
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          infoModals.forEach((modal) => {
            if (!modal.hasAttribute('hidden')) closeModal(modal);
          });
        }
      });

      update();
    }

    document.querySelectorAll('[data-routine-builder]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      const root = e.target.querySelector('[data-routine-builder]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rutina-social-proof__quotes').forEach(function (root) {
      var quotes = Array.from(root.querySelectorAll('.rutina-social-proof__quote'));
      if (quotes.length < 2) return;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var i = 0;
      setInterval(function () {
        quotes[i].classList.remove('is-active');
        i = (i + 1) % quotes.length;
        quotes[i].classList.add('is-active');
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tikri-rezultatai"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rutina-results').forEach(function (root) {
      var track = root.querySelector('.rutina-results__track');
      if (!track) return;
      var arrows = root.querySelectorAll('.rutina-results__arrow');
      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-direction');
          var card = track.querySelector('.rutina-results__card');
          var step = (card ? card.getBoundingClientRect().width : 300) + 24; /* card + gap */
          track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rutina-welcome]');
    if (!root) return;

    var DONE_KEY = 'rutinaWelcomeDone';
    var SUBMIT_KEY = 'rutinaWelcomeSubmitted';

    function store(get, key, value) {
      try {
        if (get) { return window.localStorage.getItem(key); }
        window.localStorage.setItem(key, value);
      } catch (e) { return null; }
    }
    function session(action, key) {
      try {
        if (action === 'get') { return window.sessionStorage.getItem(key); }
        if (action === 'set') { window.sessionStorage.setItem(key, '1'); }
        if (action === 'del') { window.sessionStorage.removeItem(key); }
      } catch (e) { return null; }
    }

    function open() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      store(false, DONE_KEY, '1');
      setTimeout(function () { root.hidden = true; }, 300);
    }

    root.querySelectorAll('[data-welcome-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    var copyBtn = root.querySelector('[data-welcome-copy]');
    var codeEl = root.querySelector('[data-welcome-code]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = (codeEl.textContent || '').trim();
        if (navigator.clipboard) { navigator.clipboard.writeText(code); }
        copyBtn.textContent = copyBtn.getAttribute('data-copied') || copyBtn.textContent;
      });
    }

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () { session('set', SUBMIT_KEY); });
    }

    var posted = !!root.querySelector('[data-welcome-code]');
    var fromPopup = session('get', SUBMIT_KEY) === '1';

    if (posted) {
      store(false, DONE_KEY, '1');
      session('del', SUBMIT_KEY);
      if (fromPopup) { open(); }
      return;
    }
    if (fromPopup) {
      session('del', SUBMIT_KEY);
      open();
      return;
    }
    if (store(true, DONE_KEY) === '1') return;

    var delay = parseInt(root.getAttribute('data-delay'), 10) || 6;
    setTimeout(open, delay * 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
